// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectYesNo_wrapper__Ue7+z","button":"SelectYesNo_button__FXaf8","active":"SelectYesNo_active__8do38"};